import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PlatformType } from '../../../common';
import { ImgQuery } from '../../services';
import { getImgUrlByPlatform } from '../../utils';
import { RedeemCtaTrayViewModel } from './redeem-cta-tray.view-model';

@Component({
  selector: 'osn-shared-redeem-cta-tray',
  templateUrl: './redeem-cta-tray.component.html',
  styleUrls: ['./redeem-cta-tray.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RedeemCtaTrayComponent implements OnInit {
  @Input() public vm: RedeemCtaTrayViewModel;
  @Output() public buttonClick: EventEmitter<string> = new EventEmitter();

  public imgQuery: ImgQuery;
  public fallbackUrl: string;

  constructor(@Inject(DOCUMENT) private readonly document: Document, private readonly translateService: TranslateService) {}

  public ngOnInit() {
    const mobileImg = getImgUrlByPlatform(PlatformType.Mobile, this.vm.backgroundImageUrlsByPlatform);
    const tabletImg = getImgUrlByPlatform(PlatformType.Tablet, this.vm.backgroundImageUrlsByPlatform);
    const desktopImg = getImgUrlByPlatform(PlatformType.Web, this.vm.backgroundImageUrlsByPlatform);
    this.imgQuery = {
      XS: { url: mobileImg },
      SM: { url: tabletImg },
      MD: { url: desktopImg },
      LG: { url: desktopImg },
      XL: { url: desktopImg },
    };

    this.fallbackUrl = this.vm.fallbackUrl;
  }

  public get primaryButtonText(): string {
    return this.vm?.primaryButton?.labelLocalized[this.translateService.currentLang];
  }

  public onRedeemSignupClick() {
    this.buttonClick.emit(this.vm?.primaryButton.labelLocalized.en);
  }
}
